// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconButton_iconContainer__wOATa","small":"IconButton_small__16UJV","medium":"IconButton_medium__LeY7b","large":"IconButton_large__1xFQn"};